import { HeadingPriority } from "atoms/constants/heading-priority";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import Heading from "atoms/typography/heading";
import UserBookmarkRecord from "models/view-models/user-bookmark-record";
import React from "react";
import { Link } from "react-router-dom";

interface RecentBookmarkListItemProps {
    bookmark: UserBookmarkRecord;
    iconType?: Icons;
}

const CSS_BASE_CLASS = "c-recent-bookmark-list-item";

const RecentBookmarkListItem = (props: RecentBookmarkListItemProps) => {
    const { bookmark, iconType = Icons.Bookmark } = props;
    const colorClassModifier = bookmark.getColorClassModifier();
    return (
        <div className={CSS_BASE_CLASS}>
            <Icon
                type={iconType}
                cssClassName={`${CSS_BASE_CLASS}__icon ${colorClassModifier}`}
            />
            <Heading
                cssClassName={`${CSS_BASE_CLASS}__heading`}
                priority={HeadingPriority.Five}>
                <Link
                    className={`${CSS_BASE_CLASS}__link`}
                    to={bookmark.getSectionRoute()}>
                    {bookmark.getCodeTitle()} &ndash;{" "}
                    <span className={`${CSS_BASE_CLASS}__subtitle`}>
                        {bookmark.getFullyQualifiedDisplayTitle()}
                    </span>
                </Link>
            </Heading>
        </div>
    );
};

export default RecentBookmarkListItem;
